package com.narbase.letsgo.web.models

import com.narbase.letsgo.dto.EnumDtoName
enum class ContactType(dtoName: String? = null) : EnumDtoName {
    Phone,
    Email,
    Other,
    ;

    override val dtoName = dtoName ?: this.name
}